import React from 'react'
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { userPayload } from "Pages/Admin/Users/@signals"
import { AppAntSwitch } from "@components"

export default function UserOnlyExportSwitch() {

	const { onlyExport, setOnlyExportInfo } = useAdminUsersInfo(userPayload.peek()?.userConfig?.onlyExport, "onlyExport", "userConfig")

	return <AppAntSwitch
		falseText="Full access"
		trueText="Only export"
		checked={onlyExport}
		onChange={e => setOnlyExportInfo(e.target.checked)}
	/>
}